<template>
  <header class="header _container flex items-center">
    <UIButton
      v-if="isNavigationEnabled && tabletLayout && !focusMode"
      unstyled
      class="burgerbtn fill-darkest"
      @click="isNavigationOpen = !isNavigationOpen"
    >
      <UIIcon name="menu" class="burgericon db" />
    </UIButton>
    <transition
      enter-active-class="fadeIn animated-200"
      leave-active-class="fadeOut animated-200"
      mode="out-in"
    >
      <h1
        :key="title"
        class="pagetitle f-title tl"
      >{{ !Array.isArray(title) ? title : title[0].name }}</h1>
    </transition>
    <!-- <UISelect v-else-if="$route" v-model="titleSelectForMonitor">
        <option
          v-for="option in title"
          :key="option.locationId"
          :value="option.locationId"
        >{{ option.name }}</option>
    </UISelect>-->
    <WebPanelUserDropdown
      class="userdropdown ml-auto h-100"
      :user="user"
      :dropdownItems="dropdownItems"
      v-if="user && dropdownItems"
    />
  </header>
</template>

<script>
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon';
import { useWebPanel } from './hooks';
import useMQ from './hooks/mq';
import WebPanelUserDropdown from './WebPanelUserDropdown';

// @Component({
//   components: {
//     UISelect,
//   },
//   props: {
//     title: {
//       type: [String, Array],
//       validator (value) {
//         if (Array.isArray(value)) {
//           return value.every(option => {
//             return option.hasOwnProperty('name') &&
//               option.hasOwnProperty('locationId') &&
//               typeof option.name === 'string' &&
//               typeof option.locationId === 'string';
//           });
//         }
//         return true;
//       },
//     },
//     showBurger: {
//       type: Boolean,
//       default: true,
//     },
//     showNotification: {
//       type: Boolean,
//       default: false,
//     },
//     user: {
//       type: Object,
//       default: () => {
//         return {
//           avatarUrl: 'https://api.springboardvr.com/assets/img/logos/springboardvr-icon-onwhite.png',
//           name: 'Jamie',
//         };
//       },
//     },
//     userOptions: {
//       type: Array,
//     },
//     showLogout: {
//       type: Boolean,
//       default: true,
//     },
//     showSupport: {
//       type: Boolean,
//       default: true,
//     },
//     showUserSettings: {
//       type: Boolean,
//       default: true,
//     },
//     showOrganizationSettings: {
//       type: Boolean,
//       default: true,
//     },
//   },
// })
export default {
  name: 'WebPanelHeader',
  components: {
    UIIcon,
    UIButton,
    WebPanelUserDropdown,
  },
  props: {
    user: {
      required: true,
    },
    dropdownItems: {
      type: Array,
    },
  },
  setup () {
    const { title, isNavigationOpen, isNavigationEnabled, focusMode } = useWebPanel();
    const { tabletLayout } = useMQ();

    return { title, isNavigationOpen, isNavigationEnabled, tabletLayout, focusMode };
  },
  // userMenuOpen = false;
  // notificationMenuOpen = false;

  // get tenantLogout () {
  //   return `//${window.sbvrenv.PANEL_URL}/tenantLogout`;
  // }

  // get titleSelectForMonitor () {
  //   return this.$route.params.locationId;
  // }

  // set titleSelectForMonitor (locationId) {
  //   this.$router.push({ name: 'overview', params: { locationId } });
  // }

  // openUserMenu () {
  //   handleClickOutside('.header .user-menu', this.userMenuOpen, this.closeUserMenu);
  //   this.userMenuOpen = true;
  // }

  // closeUserMenu () {
  //   this.userMenuOpen = false;
  // }

  // openNotificationMenu () {
  //   handleClickOutside('.header .notification-menu', this.notificationMenuOpen, this.closeNotificationMenu);
  //   this.notificationMenuOpen = true;
  // }

  // closeNotificationMenu () {
  //   this.notificationMenuOpen = false;
  // }

  // titleChange (e) {
  //   this.$router.push(this.title.find(option => option.name === e.target.value).routerAction);
  // }
};
</script>

<style scoped lang="postcss">
.animated-200 {
  animation-duration: 200ms;
}
.header {
  z-index: var(--zHeader);
  background-color: white;
  padding: var(--spacingSm) 0 var(--spacingSm) var(--spacingSm);
  max-height: auto;
  height: 5.6rem;
  box-shadow: var(--lightDropShadow);

  @media (--tablet) {
    padding: var(--spacingSm) 0 var(--spacingSm) var(--spacingMd);
    height: 6.6rem;
  }

  & .burgerbtn {
    /* line-height: 1.4; */
    margin-right: var(--spacingSm);
    flex: 0 0 2rem;
  }
  & .burgericon {
    width: 2rem;
    height: 2rem;
  }

  & .pagetitle {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.4;
    width: calc(100vw - 17rem);

    @media (--tablet) {
      width: auto;
    }
  }
}
</style>
